<template>
  <label class="block font-bold text-sm mb-2" :for="forId">
    <slot />
  </label>
</template>

<script>
  export default {
    name: 'BaseLabel',

    props: {
      forId: {
        type: String,
        default: '',
      },
    },
  };
</script>
